import { render } from "./MultienterPrise.vue?vue&type=template&id=2c632762&scoped=true"
const script = {}

import "./MultienterPrise.vue?vue&type=style&index=0&id=2c632762&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c632762"]])

export default __exports__